import { render, staticRenderFns } from "./ProfileCardDetails.vue?vue&type=template&id=7be84d95"
import script from "./ProfileCardDetails.vue?vue&type=script&lang=js"
export * from "./ProfileCardDetails.vue?vue&type=script&lang=js"
import style0 from "./ProfileCardDetails.vue?vue&type=style&index=0&id=7be84d95&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports